import { useEffect, useState } from 'react';
import './SaleBanner.css';

const CSV_URL =
  'https://docs.google.com/spreadsheets/d/e/' +
  '2PACX-1vTG5c_p8alj3ctPkuUYTkwBC2GIIjYH71bCWo-0QaJAAAEyvxByaWF9y9xzE4d_rfVb3tsUo1r0ZUG0' +
  '/pub?output=csv';

const SHOP_CONFIG = {
  '楽天':   { color: '#bf0000', emoji: '🛒' },
  'Yahoo!': { color: '#ff0033', emoji: '🛍️' },
  'Amazon': { color: '#ff9900', emoji: '📦' },
};

function parseCSVLine(line) {
  const result = [];
  let current = '';
  let inQuote = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuote && line[i + 1] === '"') { current += '"'; i++; }
      else { inQuote = !inQuote; }
    } else if (ch === ',' && !inQuote) {
      result.push(current); current = '';
    } else {
      current += ch;
    }
  }
  result.push(current);
  return result;
}

async function fetchActiveSales() {
  const res = await fetch(`${CSV_URL}&t=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`fetch failed: ${res.status}`);
  const text = await res.text();
  const lines = text.trim().split('\n');
  const now = Date.now();
  return lines.slice(1).flatMap((line) => {
    const cols = parseCSVLine(line);
    const startDate = cols[2] || '';
    const endDate   = cols[3] || '';
    const microcopy = cols[5] || '';
    const affiliateLink = cols[7] || '';
    if (!startDate || !endDate || !affiliateLink) return [];
    const start = new Date(startDate).getTime();
    const end   = new Date(endDate).getTime();
    if (now < start || now > end) return [];
    return [{ shop: cols[0] || '', microcopy, affiliateLink }];
  });
}

function SaleBanner() {
  const [sales, setSales] = useState([]);

  useEffect(() => {
    fetchActiveSales()
      .then(setSales)
      .catch((e) => console.warn('[SaleBanner] データ取得失敗:', e));
  }, []);

  if (sales.length === 0) return null;

  return (
    <div className="sale-banner">
      <span className="sale-banner__label">🏷️ セール開催中</span>
      <div className="sale-banner__items">
        {sales.map((sale, i) => {
          const cfg = SHOP_CONFIG[sale.shop] || { color: '#6b7280', emoji: '🛒' };
          return (
            <a
              key={i}
              href={sale.affiliateLink}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className="sale-banner__btn"
              style={{ background: cfg.color }}
            >
              {cfg.emoji} {sale.microcopy}
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default SaleBanner;
